module.exports = __webpack_public_path__ + "img/participation.644c7bec.svg";